<div class="dashboard-landing-container">
  <app-page-header></app-page-header>

  <main class="dashboard-shell">
    @if (!hasNoClientsAssigned) {
      <section class="dashboard-title-row">
        <div class="search-container" (click)="$event.stopPropagation()">
          <svg class="search-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <circle cx="11" cy="11" r="8" fill="none" stroke="currentColor" stroke-width="2"/>
            <path d="M16.5 16.5l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <input
            type="text"
            class="search-input"
            placeholder="Search document models, fields"
            (input)="onSearchInputChange($event.target.value)"
            [value]="(searchTerm$ | async) || ''"
            (keydown.escape)="onSearchDropdownClose()" />
          @if (showSearchDropdown) {
            <app-search-results-dropdown
              [results]="(searchResults$ | async) || []"
              [isSearching]="isSearching"
              [searchTerm]="(searchTerm$ | async) || ''"
              (onClose)="onSearchDropdownClose()"
              (resultSelected)="onSearchResultSelected()">
            </app-search-results-dropdown>
          }
        </div>

        <button class="analytics-btn" type="button" title="Data-Extraction" (click)="navigateToDataExtraction()">
          Explore
        </button>
        <button class="analytics-btn" type="button" title="Analytics" (click)="navigateToStatsDashboard()">
          Analytics
        </button>
      </section>
    }

    @if (isRoleCheckInProgress) {
      <div class="page-loading-state">
        <div class="docsila-loader">
          <div class="beat-loader">
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
          </div>
          <p class="loader-text">Loading your profile...</p>
        </div>
      </div>
    } @else if (isLoadingDashboard) {
      <div class="page-loading-state">
        <div class="docsila-loader">
          <div class="beat-loader">
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
            <div class="beat"></div>
          </div>
          <p class="loader-text">Loading dashboard metrics...</p>
        </div>
      </div>
    } @else if (hasNoClientsAssigned) {
      <div class="page-loading-state">
        <div class="no-clients-placeholder">
          <svg class="placeholder-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"></path>
          </svg>
          <p class="placeholder-text">Access Restricted</p>
          <p class="placeholder-subtext">Contact your administrator to get access</p>
        </div>
      </div>
    } @else {
      <section class="kpi-row">
        <article class="kpi-card kpi-unified">
          <h3>Models Trained</h3>
          <p>{{ kpis.modelsTrained | number:'1.0-0' }}</p>
        </article>
        <article class="kpi-card kpi-unified">
          <h3>Fields Trained</h3>
          <p>{{ kpis.fieldsTrained | number:'1.0-0' }}</p>
        </article>
        <article class="kpi-card kpi-unified">
          <h3>Overall Accuracy</h3>
          <p>{{ kpis.overallAccuracy | number:'1.2-2' }}%</p>
        </article>
        <article class="kpi-card kpi-unified">
          <h3>Docs Processed Today</h3>
          <p>{{ kpis.docsProcessedToday | number:'1.0-0' }}</p>
        </article>
        <article class="kpi-card kpi-unified">
          <h3>Pages Processed Today</h3>
          <p>{{ kpis.pagesProcessedToday | number:'1.0-0' }}</p>
        </article>
      </section>

      <section class="insight-cards">
        <article class="insight-card">
          <header class="insight-card-header">
            <h2>Training</h2>
            <button
              class="btn-view"
              type="button"
              aria-label="View Training"
              title="View Training"
              (click)="navigateToAdminSettings()">
              <svg class="btn-view-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="M8 5.5H5.8C5.14 5.5 4.5 6.14 4.5 6.8V14.2C4.5 14.86 5.14 15.5 5.8 15.5H13.2C13.86 15.5 14.5 14.86 14.5 14.2V12"></path>
                <path d="M11.5 4.5H15.5V8.5"></path>
                <path d="M15.5 4.5L8.8 11.2"></path>
              </svg>
            </button>
          </header>

          <div class="chart-area vertical-chart" role="img" aria-label="Accuracy by range">
            @for (bar of trainingBars; track bar.label) {
              <div class="v-bar-col">
                <div class="v-bar-wrap">
                  <div
                    class="v-bar"
                    [class.is-zero]="bar.count === 0"
                    [style.height.%]="(bar.count / trainingMax) * 100"
                    (mouseenter)="onTooltipEnter(getTrainingBarTooltip(bar), $event)"
                    (mousemove)="onTooltipMove($event)"
                    (mouseleave)="onTooltipLeave()">
                  </div>
                </div>
                <span class="v-bar-label">{{ bar.label }}</span>
              </div>
            }
          </div>

          <footer class="insight-footer">Accuracy by range</footer>
        </article>

        <article class="insight-card">
          <header class="insight-card-header">
            <h2>Operational Health</h2>
            <button
              class="btn-view"
              type="button"
              aria-label="View Operational Health"
              title="View Operational Health"
              (click)="viewOperationalHealth()">
              <svg class="btn-view-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="M8 5.5H5.8C5.14 5.5 4.5 6.14 4.5 6.8V14.2C4.5 14.86 5.14 15.5 5.8 15.5H13.2C13.86 15.5 14.5 14.86 14.5 14.2V12"></path>
                <path d="M11.5 4.5H15.5V8.5"></path>
                <path d="M15.5 4.5L8.8 11.2"></path>
              </svg>
            </button>
          </header>

          @if (operationalBars.length > 0) {
            <div class="chart-area horizontal-chart" role="img" aria-label="Top models by request volume">
              @for (bar of operationalBars; track bar.label) {
                <div class="h-row">
                  <span
                    class="h-label"
                    (mouseenter)="onTooltipEnter(getOperationalBarTooltip(bar), $event)"
                    (mousemove)="onTooltipMove($event)"
                    (mouseleave)="onTooltipLeave()">{{ bar.label }}</span>
                  <div class="h-track">
                    <div
                      class="h-fill"
                      [ngClass]="getOperationalBarHealthClass(bar)"
                      [style.width.%]="(bar.count / operationalMax) * 100"
                      (mouseenter)="onTooltipEnter(getOperationalBarTooltip(bar), $event)"
                      (mousemove)="onTooltipMove($event)"
                      (mouseleave)="onTooltipLeave()">
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="chart-area horizontal-chart no-data-placeholder" role="img" aria-label="Top models by request volume">
              <p class="no-data-text">No data available</p>
            </div>
          }

          <footer class="insight-footer">Top 10 models by request volume</footer>
        </article>

        <article class="insight-card">
          <header class="insight-card-header">
            <h2>Evaluation</h2>
            <button
              class="btn-view"
              type="button"
              aria-label="View Evaluation"
              title="View Evaluation"
              (click)="navigateToEvaluationDashboard()">
              <svg class="btn-view-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="M8 5.5H5.8C5.14 5.5 4.5 6.14 4.5 6.8V14.2C4.5 14.86 5.14 15.5 5.8 15.5H13.2C13.86 15.5 14.5 14.86 14.5 14.2V12"></path>
                <path d="M11.5 4.5H15.5V8.5"></path>
                <path d="M15.5 4.5L8.8 11.2"></path>
              </svg>
            </button>
          </header>

          @if (totalPieCount > 0) {
            <div class="chart-area pie-chart-area" role="img" aria-label="Document model status">
              <div class="pie-chart-wrap">
                <svg viewBox="0 0 36 36" class="pie-chart-svg">
                  @if (hasSingleActivePieSlice && singleActivePieSlice) {
                    <circle
                      cx="18"
                      cy="18"
                      r="11"
                      fill="none"
                      [attr.stroke]="singleActivePieSlice.bgColor"
                      stroke-width="10.6"
                      stroke-linecap="butt"
                      (mouseenter)="onPieSliceEnter(singleActivePieSlice, $event)"
                      (mousemove)="onPieSliceMove($event)"
                      (mouseleave)="onPieSliceLeave()"
                      transform="rotate(-90 18 18)">
                    </circle>
                  } @else {
                    @for (slice of pieSlices; track slice.label; let i = $index) {
                      <circle
                        cx="18"
                        cy="18"
                        r="11"
                        fill="none"
                        [attr.stroke]="slice.bgColor"
                        stroke-width="10.6"
                        stroke-linecap="butt"
                        pathLength="100"
                        [attr.stroke-dasharray]="getPieDashArray(slice.count, i)"
                        [attr.stroke-dashoffset]="getPieDashOffset(i)"
                        (mouseenter)="onPieSliceEnter(slice, $event)"
                        (mousemove)="onPieSliceMove($event)"
                        (mouseleave)="onPieSliceLeave()"
                        transform="rotate(-90 18 18)">
                      </circle>
                    }
                  }
                </svg>
              </div>

              <div class="pie-legend">
                @for (slice of pieSlices; track slice.label) {
                  <div class="legend-item" [style.background-color]="slice.bgColor" [attr.title]="getPieSliceTooltip(slice)">
                    <span class="legend-text">{{ slice.label }}</span>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="chart-area pie-chart-area no-data-placeholder" role="img" aria-label="Document model status">
              <p class="no-data-text">No data available</p>
            </div>
          }

          <footer class="insight-footer">Document model status</footer>
        </article>
      </section>

      @if (tooltipVisible) {
        <div
          #inlineTooltip
          class="dashboard-inline-tooltip"
          [style.left.px]="tooltipX"
          [style.top.px]="tooltipY">
          {{ tooltipText }}
        </div>
      }
    }
  </main>
</div>
